import LeftArrow from "Assets/Icons/LeftArrow";
import Typography from "Components/CommonComponents/Typography";
import React, { useState, useContext, useEffect } from "react";
import { Button, Row, Col, Collapse } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { filterMapUserManagement } from "utilFunctions/Constants/Constants";
import { selectInterface } from "utilFunctions/shared/PerformanceSearchBar";
import { ToastContextDispatch } from "Context/CommonContext";
import "./index.css";
import hasObjectHasNullValues from "utilFunctions/helperFunctions/utilFunctions";
import { CustomDropdownWithSelect } from "Components/CommonComponents/CustomDropdownWithSelect";
import { Input } from "Components/InputComponents/Input";
import CustomSelect from "Components/CommonComponents/CustomSelect";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import FilterIcon from "Assets/Icons/FilterIcon";
import FilterSliderComponent from "Components/FilterSliderComponent/FilterSliderComponent";
import { UserInfoContext } from "Context/CommonContext";
import { pushToDataLayerForGTM } from "utilFunctions/helperFunctions/analytics";

export interface IFilterInterface {
  id: string | null;
  name: string | null;
  email: string | null;
  phone: number | null;
  role: number[] | null;
  clearAllHandler: any;
}
export interface MyUserManagementFilterInterface {
  role?: any;
  stream?: selectInterface[];
  status?: any;
  branch?: selectInterface[];
  subjects?: selectInterface[];
  department?: selectInterface[];
  filterDataValue: any;
  setFilterDataValue: any;
  clearAllHandler: any;
  isOpenForm?: any;
  setIsOpenForm?: any;
  userInfo?: any;
  region?: any;
}
const MyUserManagementFilter = ({
  branch,
  role,
  status,
  subjects,
  region,
  stream,
  filterDataValue,
  setFilterDataValue,
  clearAllHandler,
  isOpenForm,
  setIsOpenForm,
}: MyUserManagementFilterInterface) => {
  const userName: any = {
    style: {
      flexDirection: "column",
    },
  };
  const userInfo = useContext(UserInfoContext);
  const refName = React.createRef<HTMLInputElement>();
  const refId = React.createRef<HTMLInputElement>();
  const refEmployeeId = React.createRef<HTMLInputElement>();
  const refEmail = React.createRef<HTMLInputElement>();
  const refSuperWisorEmail = React.createRef<HTMLInputElement>();
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [filterDataLabel, setFilterDataLabel] = useState<any>();
  const { screen }: any = useWindowSize();
  const [isPaneOpen, setisPaneOpen] = useState<boolean>(false);
  const [filterheadingListing, setfilterheadingListing] = useState([
    {
      name: "Name",
      nickName: "name",
      data: stream,
      singleSelect: true,
      filterSelectedData: [],
      type: "input",
    },
    {
      name: "Email",
      nickName: "email",
      data: stream,
      singleSelect: true,
      filterSelectedData: [],
      type: "input",
    },
    {
      name: "Employee Id",
      nickName: "employeeId",
      data: stream,
      singleSelect: true,
      filterSelectedData: [],
      type: "input",
    },
    {
      name: "Stream",
      nickName: "stream",
      data: stream,
      singleSelect: false,
      filterSelectedData: [],
    },
    {
      name: "Region",
      nickName: "region",
      data: region,
      singleSelect: false,
      filterSelectedData: [],
    },
    {
      name: "Branch",
      nickName: "branch",
      data: branch,
      singleSelect: false,
      filterSelectedData: [],
    },
    {
      name: "Subject",
      nickName: "subject",
      data: subjects,
      singleSelect: true,
      filterSelectedData: [],
      type: "input",
    },
    {
      name: "Status",
      nickName: "status",
      data: status,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Role",
      nickName: "fexRole",
      data: role,
      singleSelect: true,
      filterSelectedData: [],
    },
    {
      name: "Supervisor Email",
      nickName: "supervisorEmail",
      data: stream,
      singleSelect: true,
      filterSelectedData: [],
      type: "input",
    },
  ]);
  const [filterState, setFilterState] = useState<any>({
    id: null,
    name: null,
    employeeId: null,
    email: null,
    fexRole: null,
    stream: null,
    subjects: null,
    status: null,
    branch: null,
    supervisorEmail: null,
  });
  useEffect(() => {
    setfilterheadingListing([
      {
        name: "Name",
        nickName: "name",
        data: [],
        singleSelect: true,
        filterSelectedData: [],
        type: "input",
      },
      {
        name: "Email",
        nickName: "email",
        data: [],
        singleSelect: true,
        filterSelectedData: [],
        type: "input",
      },
      {
        name: "Employee Id",
        nickName: "employeeId",
        data: [],
        singleSelect: true,
        filterSelectedData: [],
        type: "input",
      },
      {
        name: "Stream",
        nickName: "stream",
        data: stream,
        singleSelect: false,
        filterSelectedData: [],
      },
      {
        name: "Region",
        nickName: "region",
        data: region,
        singleSelect: false,
        filterSelectedData: [],
      },
      {
        name: "Branch",
        nickName: "branch",
        data: branch,
        singleSelect: false,
        filterSelectedData: [],
      },
      {
        name: "Subject",
        nickName: "subject",
        data: subjects,
        singleSelect: false,
        filterSelectedData: [],
        type: "input",
      },
      {
        name: "Status",
        nickName: "status",
        data: status,
        singleSelect: true,
        filterSelectedData: [],
      },
      {
        name: "Role",
        nickName: "fexRole",
        data: role,
        singleSelect: true,
        filterSelectedData: [],
      },
      {
        name: "Supervisor Email",
        nickName: "supervisorEmail",
        data: [],
        singleSelect: true,
        filterSelectedData: [],
        type: "input",
      },
    ]);
  }, [stream, subjects, region, branch, subjects, status, role]);

  const toggle = () => setIsOpen(!isOpen);
  const applyFilter = (filterState: any) => {
    console.log(filterState, "filterState");
    if (filterState && Object.keys(filterState).length > 0) {
      if (hasObjectHasNullValues(filterState)) {
        const filterGTMData = {
          SEARCH_BY: userInfo?.employeeId || "",
          STREAM: Array.isArray(filterState?.stream)
            ? filterState.stream.map((item: any) => item.label).join(", ")
            : "",
          REGION: Array.isArray(filterState?.region)
            ? filterState.region.map((item: any) => item.label).join(", ")
            : "",
          BRANCH_NAME: Array.isArray(filterState?.branch)
            ? filterState.branch.map((item: any) => item.label).join(", ")
            : "",
          SUBJECT: Array.isArray(filterState?.subject)
            ? filterState.subject.map((item: any) => item.label).join(", ")
            : "",
          STATUS: filterState?.status?.label || "",
          USER_ROLE: filterState?.fexRole?.label || "",
        };
        pushToDataLayerForGTM({
          event: "ag_user_management_filter_users",
          ...filterGTMData,
        });

        Object.keys(filterState).map((ele) => {
          const value = Array.isArray(filterState[ele])
            ? filterState[ele] && filterState[ele].map((ele: any) => ele.value)
              ? filterState[ele].map((ele: any) => ele.value)
              : null
            : filterState[ele] != null && filterState[ele].value !== undefined
            ? filterState[ele].value
            : filterState[ele];
          const branchValue = Array.isArray(filterState[ele])
            ? filterState[ele] && filterState[ele].map((ele: any) => ele.id)
              ? filterState[ele].map((ele: any) => ele.id)
              : null
            : filterState[ele] != null && filterState[ele].id !== undefined
            ? filterState[ele].id
            : filterState[ele];
          setFilterDataValue((prevState: any) => ({
            ...prevState,
            [ele]: ele == "branch" ? branchValue : value,
          }));
          const label = Array.isArray(filterState[ele])
            ? filterState[ele] && filterState[ele].map((ele: any) => ele.label)
              ? filterState[ele].map((ele: any) => ele.label)
              : null
            : filterState[ele] != null && filterState[ele].label
            ? filterState[ele].label
            : null;
          setFilterDataLabel((prevState: any) => ({
            ...prevState,
            [ele]: label,
          }));
        });
        ["xxl", "xl", "lg"].includes(screen) && toggle();
      } else {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "Please select atleast one filter",
        });
      }
    }
  };
  const clearHandler = () => {
    if (refName.current) {
      refName.current.value = "";
    }
    if (refId.current) {
      refId.current.value = "";
    }
    if (refEmployeeId.current) {
      refEmployeeId.current.value = "";
    }
    if (refEmail.current) {
      refEmail.current.value = "";
    }
    if (refSuperWisorEmail.current) {
      refSuperWisorEmail.current.value = "";
    }
    const clearedFilter = {
      fexRole: null,
      stream: null,
      name: null,
      subjects: null,
      status: null,
      branch: null,
      employeeId: null,
      region: null,
      id: null,
      email: null,
      supervisorEmail: null,
    };
    setFilterState(clearedFilter);
    setFilterDataValue(undefined);
    const filterheadingListingArr = [...filterheadingListing].map(
      (ele: any) => {
        return { ...ele, filterSelectedData: [] };
      }
    );
    setfilterheadingListing(filterheadingListingArr);
    clearAllHandler();
  };
  const handleSingleFilterRemove = (key: string) => {
    setFilterDataValue((prevState: any) => ({
      ...prevState,
      [key]: null,
    }));
    setFilterState((prevState: any) => ({
      ...prevState,
      [key]: null,
    }));
  };

  const filterValues =
    filterDataValue && Array.isArray(Object.values(filterDataValue))
      ? [...Object.values(filterDataValue)].flatMap((element) =>
          element != null ? element : []
        )
      : [];
  const filterKeys =
    filterDataValue && Array.isArray(Object.values(filterDataValue))
      ? [...Object.keys(filterDataValue)]
      : [];
  const filterLength = filterValues.length;
  const handleAddFilterArrayList = (name: string, val: any) => {
    setFilterState((prevState: any) => ({
      ...prevState,
      [name]: val,
    }));
  };

  const addUserToggle = () => {
    setIsOpenForm(!isOpenForm);
  };
  const applyFilterHandler = () => {
    const obj: any = {};
    filterheadingListing.forEach((ele: any) => {
      if (ele.type === "input") {
        const value =
          typeof ele.filterSelectedData === "string"
            ? ele.filterSelectedData.trim()
            : "";
        if (value) {
          obj[ele.nickName] = value;
        }
        return;
      }
      if (ele.singleSelect) {
        const selectedValue = ele.filterSelectedData?.[0];
        if (selectedValue) {
          obj[ele.nickName] = selectedValue;
        }
        return;
      }
      if (ele.filterSelectedData?.length > 0) {
        obj[ele.nickName] = ele.filterSelectedData;
      }
    });
    applyFilter(obj);
    setFilterState(obj);
  };
  return (
    <div className="d-flex flex-column">
      <Row>
        {["xs", "sm", "md"].includes(screen) && (
          <FilterSliderComponent
            width={"100%"}
            isPaneOpen={isPaneOpen}
            setisPaneOpen={setisPaneOpen}
            hideHeader={true}
            filterheadingListing={filterheadingListing}
            setfilterheadingListing={setfilterheadingListing}
            applyFilterHandler={applyFilterHandler}
            filterState={filterState}
          ></FilterSliderComponent>
        )}
        <Col xs="8" sm="8" md="8" lg="3" xl="3" xxl="3" className="pl-0">
          <div className="d-flex flex-row align-items-center">
            <LeftArrow
              className={"cursorHoverCSS mr-3 ml-3"}
              onClick={() => {
                navigate("/admin/dashboard", {
                  replace: true,
                  state: {
                    selectedStudent: null,
                  },
                });
              }}
            />
            <Typography
              variant={["xs", "sm", "md"].includes(screen) ? "h6" : "h4"}
              color="black"
            >
              User Management
            </Typography>
            {["xs", "sm", "md"].includes(screen) && (
              <Button
                className="pl-2"
                color="aeslPrimary"
                size="sm"
                outline
                onClick={() => addUserToggle()}
              >
                Add
              </Button>
            )}
          </div>
        </Col>
        {["xxl", "xl", "lg"].includes(screen) ? (
          <Col
            xs="9"
            sm="9"
            md="9"
            lg="9"
            xl="9"
            xxl="9"
            className="w-100 d-flex flex-row justify-content-end "
          >
            <div className="d-flex flex-row justify-content-start align-items-center chipContainer filterChipContainer">
              {filterKeys.map((item: any, index: any) => {
                return filterDataLabel[item] &&
                  filterDataLabel[item] != null ? (
                  <div key={index} className="chip">
                    <span className="font-weight-bold">
                      {filterMapUserManagement[item]} :
                    </span>
                    <span>
                      {filterDataLabel[item] &&
                      filterDataLabel[item] != null &&
                      Array.isArray(filterDataLabel[item]) &&
                      filterDataLabel[item].length > 0
                        ? filterDataLabel[item].join(", ")
                        : filterDataLabel[item]}
                    </span>
                    <span
                      className="chipCrossicon cursorHoverCSS"
                      onClick={() => {
                        handleSingleFilterRemove(item);
                      }}
                    >
                      &nbsp;X
                    </span>
                  </div>
                ) : null;
              })}
            </div>
            <div
              className={`d-flex flex-row h-10 ml-3 ${
                filterLength != 0 ? "mr-n3" : ""
              }`}
            >
              {filterLength != 0 ? (
                <div
                  className="clearAllButtonStyle cursorHoverCSS"
                  onClick={() => {
                    clearHandler();
                  }}
                >
                  Clear all
                </div>
              ) : null}
              {["xxl", "xl", "lg"].includes(screen) && (
                <Button
                  className="plannerButtonStyle"
                  color="aeslPrimary"
                  size="sm"
                  outline
                  onClick={() => addUserToggle()}
                >
                  Add user
                </Button>
              )}
              <Button
                className="plannerButtonStyle"
                color="aeslPrimary"
                size="sm"
                outline
                onClick={() => toggle()}
              >
                Filter
              </Button>
              {filterLength != 0 ? (
                <div className="filterButtonTip">
                  <span>{filterLength}</span>
                </div>
              ) : null}
            </div>
          </Col>
        ) : (
          <Col
            xs="4"
            sm="4"
            md="4"
            className="d-flex align-items-center justify-content-end p-1"
          >
            {filterLength != 0 ? (
              <div className="d-flex">
                <div
                  className="clearAllButtonStyle cursorHoverCSS"
                  onClick={() => {
                    clearHandler();
                  }}
                >
                  Clear all
                </div>
                <FilterIcon
                  onClick={() => {
                    setisPaneOpen(!isPaneOpen);
                  }}
                />
              </div>
            ) : (
              <div
                className="d-flex align-items-center"
                onClick={() => {
                  setisPaneOpen(!isPaneOpen);
                }}
              >
                <span className="filterSpan">Filter</span>
                <FilterIcon />
              </div>
            )}
            {filterLength != 0 ? (
              <div className="userfilterButtonTipMB">{filterLength}</div>
            ) : null}
          </Col>
        )}
      </Row>

      <Collapse isOpen={isOpen}>
        <div className="mt-2">
          <Typography variant="body5" color="black-t">
            &nbsp;Filter By
          </Typography>
          <Row>
            <Col xxl="3" xl="3" lg="4" md="4" xs="12" sm="12">
              <div className="ml-1 mt-1">
                <Input
                  className="filterInputBox"
                  id="name"
                  ref={refName}
                  value={filterState.name}
                  name="name"
                  type="text"
                  label="Full Name"
                  placeholder="Enter full name"
                  onChange={(e) => {
                    handleAddFilterArrayList("name", e.target.value);
                  }}
                />
              </div>
            </Col>
            <Col xxl="3" xl="3" lg="4" md="4" xs="12" sm="12">
              <div className="ml-2 mt-1">
                <Input
                  className="filterInputBox"
                  id="email"
                  ref={refEmail}
                  name="email"
                  type="email"
                  label="Email"
                  placeholder="Enter email"
                  onChange={(e) => {
                    handleAddFilterArrayList("email", e.target.value);
                  }}
                  {...userName}
                />
              </div>
            </Col>
            <Col xxl="3" xl="3" lg="4" md="4" xs="12" sm="12">
              <div className="ml-2 mt-1">
                <Input
                  className="filterInputBox"
                  id="employeeId"
                  ref={refEmployeeId}
                  name="employeeId"
                  type="text"
                  label="employeeId"
                  placeholder="Enter employeeId"
                  onChange={(e) => {
                    handleAddFilterArrayList("employeeId", e.target.value);
                  }}
                />
              </div>
            </Col>
            <Col xxl="3" xl="3" lg="4" md="4" xs="12" sm="12">
              <div className="ml-2">
                <label className="plannerFilterLabelStyle">Stream</label>
                <CustomDropdownWithSelect
                  isSelected={filterState?.lang != null ? true : false}
                  placeholderLabel="Select stream"
                  isInPerformance={true}
                  options={stream}
                  menuPlacement="bottom"
                  isClearable={false}
                  isSearchable={true}
                  isMulti={true}
                  isSearchableDrop={true}
                  isDropdownSelect={true}
                  top={"0px"}
                  width="100%"
                  menuShouldScrollIntoView={true}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  onChange={(selected: any) => {
                    if (
                      selected &&
                      Array.isArray(selected) &&
                      selected.length > 0
                    ) {
                      handleAddFilterArrayList("stream", selected);
                    } else {
                      handleAddFilterArrayList("stream", null);
                    }
                  }}
                  value={filterState?.stream}
                />
              </div>
            </Col>
            <Col xxl="3" xl="3" lg="4" md="4" xs="12" sm="12">
              <div className="ml-2">
                <label className="plannerFilterLabelStyle">Region</label>
                <CustomDropdownWithSelect
                  isSelected={filterState?.region != null ? true : false}
                  placeholderLabel="Select region"
                  isInPerformance={true}
                  options={region}
                  menuPlacement="bottom"
                  isClearable={false}
                  isSearchable={true}
                  isMulti={true}
                  isSearchableDrop={true}
                  isDropdownSelect={true}
                  top={"0px"}
                  width="100%"
                  menuShouldScrollIntoView={true}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  onChange={(selected: any) => {
                    if (
                      selected &&
                      Array.isArray(selected) &&
                      selected.length > 0
                    ) {
                      handleAddFilterArrayList("region", selected);
                    } else {
                      handleAddFilterArrayList("region", null);
                    }
                  }}
                  value={filterState?.region}
                />
              </div>
            </Col>
            <Col xxl="3" xl="3" lg="4" md="4" xs="12" sm="12">
              <div className="ml-2">
                <label className="plannerFilterLabelStyle">Branch</label>
                <CustomDropdownWithSelect
                  isSelected={filterState?.branch != null ? true : false}
                  placeholderLabel="Select branch"
                  isInPerformance={true}
                  options={branch}
                  menuPlacement="bottom"
                  isClearable={false}
                  isSearchable={true}
                  isMulti={true}
                  isSearchableDrop={true}
                  isDropdownSelect={true}
                  top={"0px"}
                  width="100%"
                  menuShouldScrollIntoView={true}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  onChange={(selected: any) => {
                    if (
                      selected &&
                      Array.isArray(selected) &&
                      selected.length > 0
                    ) {
                      handleAddFilterArrayList("branch", selected);
                    } else {
                      handleAddFilterArrayList("branch", null);
                    }
                  }}
                  value={filterState?.branch}
                />
              </div>
            </Col>

            <Col xxl="3" xl="3" lg="4" md="4" xs="12" sm="12">
              <div className="ml-1 mt-1">
                <label className="plannerFilterLabelStyle">Subject</label>
                <CustomDropdownWithSelect
                  isSelected={filterState?.lang != null ? true : false}
                  placeholderLabel="Select subject"
                  isInPerformance={true}
                  options={subjects}
                  menuPlacement="bottom"
                  isClearable={false}
                  isSearchable={true}
                  isMulti={true}
                  isSearchableDrop={true}
                  isDropdownSelect={true}
                  top={"0px"}
                  width="100%"
                  menuShouldScrollIntoView={true}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  onChange={(selected: any) => {
                    if (
                      selected &&
                      Array.isArray(selected) &&
                      selected.length > 0
                    ) {
                      handleAddFilterArrayList("subject", selected);
                    } else {
                      handleAddFilterArrayList("subject", null);
                    }
                  }}
                  value={filterState?.subject}
                />
              </div>
            </Col>
            <Col xxl="3" xl="3" lg="4" md="4" xs="12" sm="12">
              <div className="ml-2 mt-1">
                <label className="plannerFilterLabelStyle">Status</label>
                <CustomSelect
                  isSelected={filterState?.status != null ? true : false}
                  placeholder="Select status"
                  isInPerformance={false}
                  options={status}
                  menuPlacement="bottom"
                  isClearable={true}
                  isSearchable={true}
                  isSearchableDrop={true}
                  isDropdownSelect={true}
                  top={"0px"}
                  width="100%"
                  menuShouldScrollIntoView={true}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  onChange={(selected: any) => {
                    handleAddFilterArrayList("status", selected);
                  }}
                  value={filterState?.status}
                />
              </div>
            </Col>
            <Col xxl="3" xl="3" lg="4" md="4" xs="12" sm="12">
              <div className="ml-2 mt-1">
                <label className="plannerFilterLabelStyle">Role</label>
                <CustomSelect
                  isSelected={filterState?.fexRole != null ? true : false}
                  placeholder="Select role"
                  isInPerformance={false}
                  options={role}
                  menuPlacement="bottom"
                  isClearable={true}
                  isSearchable={true}
                  isSearchableDrop={true}
                  isDropdownSelect={true}
                  top={"0px"}
                  menuShouldScrollIntoView={true}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  onChange={(selected: any) => {
                    handleAddFilterArrayList("fexRole", selected);
                  }}
                  value={filterState?.fexRole}
                />
              </div>
            </Col>
            <Col xxl="3" xl="3" lg="4" md="4" xs="12" sm="12">
              <div className="ml-2 mt-2">
                <Input
                  className="filterInputBox"
                  id="supervisorEmail"
                  ref={refSuperWisorEmail}
                  name="supervisorEmail"
                  type="text"
                  label="Supervisor Email"
                  placeholder="Supervisor Email"
                  onChange={(e) => {
                    handleAddFilterArrayList("supervisorEmail", e.target.value);
                  }}
                />
              </div>
            </Col>
          </Row>
          <div className="d-flex flex-row justify-content-end mr-2">
            <button className="resetButton" onClick={() => clearHandler()}>
              Reset
            </button>
            <button
              className="applyButtonFilter"
              onClick={() => applyFilter(filterState)}
            >
              Apply Filter
            </button>
          </div>
        </div>
      </Collapse>
    </div>
  );
};
export default MyUserManagementFilter;
